import { message } from 'antd';
import { put, takeLatest } from 'redux-saga/effects';
import { logger } from 'services';
import { addTaskDependencyInProjectTemplate, updateTaskDependenciesInProjectTemplate } from '../../actions';
import { addProjectTemplateTaskDependency, updateProjectTemplateTaskDependencies } from '../../slices';
function* addTemplateTaskDependencySaga(action) {
    try {
        const { payload: { taskId, dependentTaskId, dependencyType, lag } } = action;
        yield put(addProjectTemplateTaskDependency({
            dependentTaskId,
            taskId,
            dependencyType,
            lag
        }));
    } catch (error) {
        logger.error('addProjectTemplateTaskDependency failed', {
            error
        });
        message.error('There was an error updating dependencies, please try later');
    }
}
function* updateTemplateTaskDependenciesSaga(action) {
    try {
        const { payload: { taskId, dependentTasks } } = action;
        yield put(updateProjectTemplateTaskDependencies({
            taskId,
            dependentTasks
        }));
    } catch (error) {
        logger.error('updateProjectTemplateTaskDependencies failed', {
            error
        });
        message.error('There was an error updating dependencies, please try later');
    }
}
export function* watchAddTemplateTaskDependencySaga() {
    yield takeLatest(addTaskDependencyInProjectTemplate.type, addTemplateTaskDependencySaga);
    yield takeLatest(updateTaskDependenciesInProjectTemplate.type, updateTemplateTaskDependenciesSaga);
}
